"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateImageFileSize = exports.validateImageDimensions = exports.getFileSourceType = exports.getFileExtension = exports.filterByValidFileExtension = exports.FileExtensionMap = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _SourceItems = require("../constants/SourceItems");
var _constants = require("@studio/constants");
var getFileSourceType = exports.getFileSourceType = function getFileSourceType(fileName) {
  if (!!fileName) {
    return FileExtensionMap[getFileExtension(fileName)];
  }
  return '';
};
var getFileExtension = exports.getFileExtension = function getFileExtension(fileName) {
  var extPattern = /\.[0-9a-z]+$/i;
  var matches = extPattern.exec(fileName);
  if (!Array.isArray(matches)) return '';
  var _matches = (0, _slicedToArray2["default"])(matches, 1),
    extMatch = _matches[0];
  return extMatch.toLowerCase();
};
var FileExtensionMap = exports.FileExtensionMap = {
  '.jpg': _SourceItems.IMAGE_FILE,
  '.jpeg': _SourceItems.IMAGE_FILE,
  '.gif': _SourceItems.IMAGE_FILE,
  '.png': _SourceItems.IMAGE_FILE,
  '.mp4': _SourceItems.VIDEO_FILE,
  '.mp3': _SourceItems.AUDIO_FILE,
  '.wav': _SourceItems.AUDIO_FILE,
  '.pdf': _SourceItems.PDF_FILE,
  '.m4v': _SourceItems.VIDEO_FILE,
  '.avi': _SourceItems.VIDEO_FILE,
  '.mov': _SourceItems.VIDEO_FILE,
  '.wmv': _SourceItems.VIDEO_FILE,
  '.webm': _SourceItems.VIDEO_FILE,
  '.mpeg': _SourceItems.VIDEO_FILE,
  '.mpg': _SourceItems.VIDEO_FILE,
  '.mpg2': _SourceItems.VIDEO_FILE,
  '.mpe': _SourceItems.VIDEO_FILE,
  '.mpv': _SourceItems.VIDEO_FILE,
  '.qt': _SourceItems.VIDEO_FILE
};

/**
 * @param {Array} templates the data array to filter
 * @param {String} fileType the data array to filter
 * @return {*}
 */
var filterByValidFileExtension = exports.filterByValidFileExtension = function filterByValidFileExtension(templates) {
  var fileType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return templates.filter(function (template) {
    var extension = getFileExtension(template.name || template.key);
    if (fileType) {
      return FileExtensionMap[extension] === fileType;
    }
    return !!FileExtensionMap[extension];
  });
};
var ImageDimensionLimits = {
  height: 1080,
  width: 1920
};

/**
 * @param {File} file the file to be validated
 * @return {Promise<boolean>} A promise that resolves with a boolean value.
 * Resolves with true if the file's dimensions are valid.
 * and false if the dimensions are not valid.
 */
var validateImageDimensions = exports.validateImageDimensions = function validateImageDimensions(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    if (getFileSourceType(file.name) !== _SourceItems.IMAGE_FILE) {
      // Resolve with true for non-image files(e.g .pdf) to skip dimension validation on UI.
      resolve(true);
    } else {
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          var isValid = height <= ImageDimensionLimits.height && width <= ImageDimensionLimits.width;
          resolve(isValid);
        };
        image.onerror = function () {
          // Resolve with false for image loading errors
          // to facilitate error handling in the main file.
          resolve(false);
        };
      };
    }
  });
};

/**
 * @param {File} file the file to be validated
 * Returns true if the file size is less than or equal to the maximum file size.
 */
var validateImageFileSize = exports.validateImageFileSize = function validateImageFileSize(file) {
  return +file.size <= _constants.MAX_IMAGE_SIZE_IN_BYTES;
};